import MaterialTable from 'material-table'
import React, { useEffect, useRef, useState } from 'react'
import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from "@material-ui/core/styles";
import CliniqueService from '../../services/CliniqueService'
import { toast } from "react-toastify";
import { Grid, Button, Container, Typography, Box } from '@material-ui/core'
import { TextField } from '@material-ui/core'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useSelector } from 'react-redux'
import { Alert, Autocomplete } from "@material-ui/lab";

import { Modal } from "antd";
import { useReactToPrint } from 'react-to-print';
import './styles.css'
import TypeClientService from '../../services/TypeClientService';
import ClientService from '../../services/ClientService';
import BonClientService from '../../services/BonClientService';

const useVenteStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  alert: {
    margin: theme.spacing(2, 0),
    borderRadius: 8,
  },
  quotaWarning: {
    backgroundColor: '#fff3e0',
    border: '1px solid #ff9800',
    color: '#e65100',
    padding: theme.spacing(2),
    borderRadius: 8,
    marginBottom: theme.spacing(2),
  }
}));

const VendreBons = () => {
  const auth = useSelector((state) => state.auth);
  const [prodVenduPending, setProdVenduPending] = useState([])
  const [exportData, setExportData] = useState([]);
  const [reportPrVendu, setReportPrVendu] = useState([]);

  const [prod, setProd] = useState('')
  const [prix, setPrix] = useState(0)
  const [codeBarre, setCodeBarre] = useState([])
  const [total, setTotal] = useState(0)

  const [modePayement, setModePayement] = useState('ESPECE');
  const [valueRemise, setValueRemise] = useState('0');
  const [montant, setMontant] = React.useState(0);
  const [produit, setProduit] = React.useState([]);
  const [allProduct, setAllProduct] = useState([])
  const [quota, setQuota] = React.useState(0);
  const [solde, setSolde] = React.useState(0);
  const [remise, setRemise] = React.useState(0);
  const [soldeApresVente, setSoldeApresVente] = useState(0);
  const [quotaDepasse, setQuotaDepasse] = useState(false);

  const componentRef = useRef();
  const refPrint = useRef();
  const formRef = useRef();
  const formProduitRef = useRef();

  const [type, setType] = useState([])
  const [clients, setClients] = useState([])

  const [printBillModalVisibility, setPrintBillModalVisibilty] = useState(false);
  const [valider, setValider] = useState(false);

  const classes = useVenteStyles();

  const handleType = async (value, props) => {
    await ClientService.getTypeClient(value)
      .then((response) => {
        var data = response.data
        setClients(data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    const fetchData = async () => {
      await CliniqueService.getAllProduitDistincts()
        .then((response) => {
          setAllProduct(response.data)
        })
        .catch(e => {
          console.log(e);
        });

      await CliniqueService.getAllProductCodeBarre()
        .then((response) => {
          setCodeBarre(response.data)
        })
        .catch(e => {
          console.log(e);
        });

      await TypeClientService.getTypeClient()
        .then((response) => {
          setType(response.data)
        })
        .catch(e => {
          console.log(e);
        });
    }

    fetchData();
  }, [prodVenduPending])

  const handleCodeBarre = async (value, props) => {
    await CliniqueService.getCodeBarre(value)
      .then((response) => {
        var data = response.data
        setProd(data[0].nomProd)
        setPrix(data[0].prixProd)
        setValider(true)
      })
      .catch((error) => {
        console.log(error)
        setValider(false)
      })
  }

  const handleChangeValue = async (value, props) => {
    await CliniqueService.getNomProd(value)
      .then((response) => {
        var data = response.data
        setPrix(data[0].prixProd)
        setValider(true)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const refreshProdExport = async () => {
    await CliniqueService.getProdReport()
      .then((response) => {
        setExportData(response.data)
      })
      .catch(e => {
        console.log(e);
      });
  }

  const refreshProdVendus = async () => {
    await BonClientService.getBonClientPending()
      .then((response) => {
        setProdVenduPending(response.data)
        // Recalculer le total après rafraîchissement
        const sum = response.data.reduce((result, item) => result + item.total, 0);
        setTotal(sum);
      })
      .catch(e => {
        console.log(e);
      });
  }

  const paperStyle = { padding: '0 15px 40px 15px', width: 500, height: 1200 }
  const btnStyle = { marginTop: 2, width: '100%', height: '90%', fontSize: '25px', backgroundColor: '#F96B2B', color: 'white' }

  const initialVentes = {
    idType: '',
    idClient: '',
    beneficiaire: '',
  }

  const validationSchemaVente = Yup.object().shape({
    idType: Yup.number().required("Required"),
    idClient: Yup.number().required("Required"),
    beneficiaire: Yup.string(),
  })

  const initialValues = {
    codeBarre: '',
    prixProd: prix,
    nomProd: '',
    qtVdu: 1,
  }

  const validationSchema = Yup.object().shape({
    codeBarre: Yup.number(),
    prixProd: Yup.number(),
    nomProd: Yup.string(),
    qtVdu: Yup.number(),
  })

  // Fonction pour reset tous les champs après vente
  const resetAllFields = () => {
    // Reset form Vente
    if (formRef.current) {
      formRef.current.resetForm();
    }
    
    // Reset form Produit
    if (formProduitRef.current) {
      formProduitRef.current.resetForm();
    }
    
    // Reset states
    setProd('');
    setPrix(0);
    setTotal(0);
    setModePayement('ESPECE');
    setValueRemise('0');
    setMontant(0);
    setProduit([]);
    setQuota(0);
    setSolde(0);
    setRemise(0);
    setSoldeApresVente(0);
    setQuotaDepasse(false);
    setClients([]);
    
    // Reset produits en attente
    setProdVenduPending([]);
  }

  // Fonction pour vider uniquement le formulaire produit
  const resetFormProduit = () => {
    if (formProduitRef.current) {
      formProduitRef.current.resetForm();
    }
    setProd('');
    setPrix(0);
    setValider(false);
  }

  // Fonction pour vérifier si le quota est dépassé pour un client donné
  const verifierQuotaClient = (clientQuota, clientSolde, currentTotal) => {
    const nouveauSolde = clientSolde + currentTotal;
    return nouveauSolde > clientQuota;
  }

  // Calculer le solde après vente
  const calculerSoldeApresVente = () => {
    const nouveauSolde = solde + total;
    setSoldeApresVente(nouveauSolde);
    
    // Vérifier si le quota est dépassé
    const depasse = verifierQuotaClient(quota, solde, total);
    setQuotaDepasse(depasse);
  }

  // Mettre à jour le calcul quand le total ou le solde change
  useEffect(() => {
    if (solde > 0 && total >= 0) {
      calculerSoldeApresVente();
    }
  }, [total, solde, quota]);

  const onSubmitVente = async (values, props) => {
    // Vérifier si le quota est dépassé
    if (quotaDepasse) {
      toast.error("La vente ne peut pas être effectuée : le solde dépasserait le quota autorisé !", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (total === 0) {
      toast.error("Il n'y a pas de produits en cours ", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    var depense = {
      "idClient": values.idClient,
      "speudo": auth.nom,
      "vendeur": auth.nom,
      "idType": values.idType,
      "beneficiaire": values.beneficiaire,
    }

    let produitsAVendre = [];

    if (values.idType === 1) {
      prodVenduPending.forEach((product) => {
        product.idClient = depense.idClient;
        product.speudo = depense.speudo;
        product.vendeur = depense.vendeur;
        product.idType = depense.idType;
        product.beneficiaire = depense.beneficiaire;
        product.total_remise = product.prixProdVendu - ((product.prixProdVendu * remise) / 100);
        produitsAVendre.push(product);
      });
    } else {
      let remise_client = parseInt(100 - remise);
      prodVenduPending.forEach((product) => {
        product.idClient = depense.idClient;
        product.speudo = depense.speudo;
        product.vendeur = depense.vendeur;
        product.idType = depense.idType;
        product.beneficiaire = depense.beneficiaire;
        product.total_client = product.prixProdVendu - ((product.prixProdVendu * remise_client) / 100);
        product.total_ipm = product.prixProdVendu - ((product.prixProdVendu * remise) / 100);
        produitsAVendre.push(product);
      });
    }

    try {
      const response = await BonClientService.vendreBons({ "prdVendus": produitsAVendre });
      toast.success("Vos produits sont bien vendus avec succès...", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      
      setReportPrVendu(response.data);
      setPrintBillModalVisibilty(true);
      refreshProdVendus();
      
      // Reset tous les champs après vente réussie
      resetAllFields();
      
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const renderVente = () => {
    return (
      <div>
        <Formik 
          innerRef={formRef}
          initialValues={initialVentes} 
          validationSchema={validationSchemaVente} 
          onSubmit={onSubmitVente}
        >
          {(props) => (
            <Form className={classes.root} style={{ display: 'flex', flexDirection: 'row' }} noValidate>
              <Grid item xs={4}>
                <Autocomplete
                  id="idType"
                  name="idType"
                  options={type}
                  getOptionSelected={(option, value) => option.designation === value.designation}
                  getOptionLabel={option => option.designation}
                  onChange={(e, v, r) => {
                    handleType(v?.idType);
                    setModePayement(v?.designation);
                    props.setFieldValue("idType", v?.idType);
                    // Reset client quand le type change
                    props.setFieldValue("idClient", '');
                    setQuota(0);
                    setSolde(0);
                    setRemise(0);
                    setQuotaDepasse(false); // Réinitialiser l'état quotaDepasse
                  }}
                  renderInput={params => (
                    <Field as={TextField} {...params} name="idType" label="Type Client" variant="outlined" fullWidth
                      error={props.errors.idType && props.touched.idType}
                      helperText={<ErrorMessage name='idType' />} required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id="idClient"
                  name="idClient"
                  options={clients}
                  getOptionSelected={(option, value) => option.nom === value.nom}
                  getOptionLabel={option => option.nom}
                  onChange={(e, v, r) => {
                    const clientQuota = v?.quota || 0;
                    const clientSolde = v?.solde || 0;
                    const clientRemise = v?.remise || 0;
                    
                    props.setFieldValue("idClient", v?.idClient);
                    setQuota(clientQuota);
                    setSolde(clientSolde);
                    setRemise(clientRemise);
                    
                    // Vérifier immédiatement si le quota est dépassé pour ce nouveau client
                    const depasse = verifierQuotaClient(clientQuota, clientSolde, total);
                    setQuotaDepasse(depasse);
                  }}
                  renderInput={params => (
                    <Field as={TextField} {...params} name="nom" label="Nom Client" variant="outlined" fullWidth
                      error={props.errors.nom && props.touched.nom}
                      helperText={<ErrorMessage name='nom' />} required
                    />
                  )}
                />
              </Grid>
              {modePayement === 'INDIVIDUELS' &&
                <Grid item xs={2}>
                  <Field as={TextField} name='beneficiaire' label='Bénéficiaire' fullWidth variant="outlined"
                    error={props.errors.beneficiaire && props.touched.beneficiaire}
                    helperText={<ErrorMessage name='beneficiaire' />} required
                    value={props.values.beneficiaire}
                  />
                </Grid>
              }
              <Grid item xs={4}>
                <Button 
                  type='submit' 
                  style={{
                    ...btnStyle, 
                    backgroundColor: quotaDepasse ? '#f44336' : '#F96B2B',
                    cursor: quotaDepasse ? 'not-allowed' : 'pointer'
                  }} 
                  variant='contained'
                  disabled={quotaDepasse}
                >
                  {quotaDepasse ? 'Quota Dépassé' : 'Vendre'}
                </Button>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  useEffect(() => {
    const fetchData = async () => {
      await BonClientService.getBonClientPending()
        .then((response) => {
          setProdVenduPending(response.data)
          // Calculer le total initial
          const sum = response.data.reduce((result, item) => result + item.total, 0);
          setTotal(sum);
        })
        .catch(e => {
          console.log(e);
        });

      await CliniqueService.getProdReport()
        .then((response) => {
          setExportData(response.data)
        })
        .catch(e => {
          console.log(e);
        });
    }

    fetchData();
  }, [])

  const cartcolumns = [
    {
      title: "Produit",
      dataIndex: "nomProd",
    },
    {
      title: "Quantity",
      dataIndex: "qtVdu",
      render: (id, record) => (
        <div>
          <b>{record.qtVdu}</b>
        </div>
      ),
    },
    {
      title: "Prix",
      dataIndex: "prixProdVendu",
    },
    {
      title: "Total",
      dataIndex: "total",
    }
  ];

  const colCart = [
    { field: 'codeIdProd', headerName: 'ID', width: 100, hide: true },
    {
      field: 'nomProd',
      headerName: 'Produit',
      fontSize: 12,
      fontWeight: 'bold',
      width: 250
    },
    {
      field: 'qtVdu',
      headerName: 'Quantity',
      fontSize: 12,
      fontWeight: 'bold',
      width: 130
    },
    {
      field: 'prixProdVendu',
      headerName: 'Prix unitaire',
      fontSize: 12,
      fontWeight: 'bold',
      width: 150
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 170
    }
  ]

  const onSubmit = async (values, props) => {
    var today = new Date()
    var produit = {
      "codeBarre": values.codeBarre,
      "prixProdVendu": prix,
      "nomProd": prod === '' ? values.nomProd : prod,
      "dateInsert": today.getFullYear() + "-" + parseInt(today.getMonth() + 1) + "-" + today.getDate(),
      "qtVdu": values.qtVdu,
      "speudo": auth.nom
    }

    try {
      const response = await BonClientService.createBonClient(produit);
      setValider(false)

      if (response.data.message === "Produit insuffisant dans le stock") {
        toast.error("Produit Insuffisant dans le stock...", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        toast.success("Produit ajouté avec succès...", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        
        // Vider le formulaire produit après validation
        resetFormProduit();
      }

      refreshProdVendus()
      refreshProdExport()
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  // Fonction pour supprimer un produit avec mise à jour du solde
  const handleDeleteProduit = (selectedRow) => {
    return new Promise((resolve, reject) => {
      BonClientService.deleteBon(selectedRow.idBon)
        .then((response) => {
          toast.success("Produit vendu supprimé avec succès...", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          
          // Mettre à jour le total en soustrayant le montant du produit supprimé
          const nouveauTotal = total - selectedRow.total;
          setTotal(nouveauTotal);
          
          refreshProdVendus();
          setTimeout(() => resolve(), 1000);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setTimeout(() => reject(), 1000);
        });
    });
  }

  const columns = [
    {
      title: "PRODUIT", field: "nomProd"
    },
    { title: "PRIX PRODUIT", field: "prixProdVendu", filterPlaceholder: "filter" },
    { title: "QUANTITE VENDUE", field: "qtVdu", filterPlaceholder: "filter" },
  ]

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {renderVente()}
          
          {/* Affichage des informations de quota */}
          {quota > 0 && (
            <Box className={classes.quotaWarning}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3}>
                  <Typography variant="h6" style={{ color: '#017679' }}>
                    Total: {total.toLocaleString()} F
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography variant="h6" style={{ color: 'gray' }}>
                    Quota: {quota.toLocaleString()} F
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography variant="h6" style={{ color: 'green' }}>
                    Remise: {remise}%
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      color: quotaDepasse ? 'crimson' : 'green',
                      fontWeight: 'bold'
                    }}
                  >
                    Solde: {solde.toLocaleString()} F
                  </Typography>
                </Grid>
              </Grid>
              
              {/* Affichage du solde après vente et alerte si quota dépassé */}
              {solde > 0 && (
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>Solde après vente:</strong> {soldeApresVente.toLocaleString()} F
                  </Typography>
                  {quotaDepasse && (
                    <Alert 
                      severity="error" 
                      className={classes.alert}
                      action={
                        <Button 
                          color="inherit" 
                          size="small"
                          onClick={() => {
                            // Vider le panier
                            setProdVenduPending([]);
                            setTotal(0);
                          }}
                        >
                          Vider le panier
                        </Button>
                      }
                    >
                      <strong>ATTENTION!</strong> La vente ne peut pas être effectuée. 
                      Le solde après vente ({soldeApresVente.toLocaleString()} F) dépasserait 
                      le quota autorisé ({quota.toLocaleString()} F) de {(soldeApresVente - quota).toLocaleString()} F.
                    </Alert>
                  )}
                </Box>
              )}
            </Box>
          )}
        </div>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Container maxWidth="md">
              <Formik 
                innerRef={formProduitRef}
                initialValues={initialValues} 
                validationSchema={validationSchema} 
                onSubmit={onSubmit}
              >
                {(props) => (
                  <Form noValidate>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Autocomplete
                          id="nomProd"
                          name="nomProd"
                          options={allProduct}
                          getOptionLabel={option => option.nomProd}
                          getOptionSelected={(option, value) => option === value}
                          onChange={(e, v, r) => {
                            handleChangeValue(v?.nomProd)
                            props.setFieldValue("nomProd", v?.nomProd)
                          }}
                          value={allProduct.find(p => p.nomProd === prod) || null}
                          renderInput={params => (
                            <Field as={TextField} {...params} name="nomProd" label="Produit" variant="outlined" fullWidth
                              error={props.errors.nomProd && props.touched.nomProd}
                              helperText={<ErrorMessage name='nomProd' />} required autoFocus="autofocus"
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Autocomplete
                          id="codeBarre"
                          name="codeBarre"
                          options={codeBarre}
                          getOptionLabel={option => option.codeBarre}
                          getOptionSelected={(option, value) => option.codeBarre === value.codeBarre}
                          onChange={(e, v, r) => {
                            props.setFieldValue("codeBarre", v?.codeBarre)
                            handleCodeBarre(v?.codeBarre)
                          }}
                          autoHighlight={true}
                          selectOnFocus
                          clearOnBlur
                          renderInput={params => (
                            <Field as={TextField} {...params} name="codeBarre" label="CodeBarre" variant="outlined" fullWidth
                              error={props.errors.codeBarre && props.touched.codeBarre}
                              helperText={<ErrorMessage name='codeBarre' />} required
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Field as={TextField} name="qtVdu" label='Quantité vendue' fullWidth variant="outlined"
                          error={props.errors.qtVdu && props.touched.qtVdu}
                          helperText={<ErrorMessage name='qtVdu' />} required
                          onChange={(e) => { props.setFieldValue("qtVdu", e.target.value) }}
                          value={props.values.qtVdu}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Field as={TextField} name="prixProd" placeholder='Prix produit' fullWidth variant="outlined"
                          error={props.errors.prixProd && props.touched.prixProd}
                          helperText={<ErrorMessage name='prixProd' />} required
                          value={prix}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button type='submit' style={btnStyle} variant='contained'>Valider</Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Container>
          </Grid>

          <Grid item xs={8}>
            <MaterialTable
              columns={columns}
              data={prodVenduPending}
              onRowClick={(evt, rowData) => { }}
              editable={{
                onRowAdd: (newRow) => new Promise((resolve, reject) => {
                  refreshProdVendus()
                  setTimeout(() => resolve(), 500)
                }),
                onRowUpdate: (newRow, oldRow) => new Promise((resolve, reject) => {
                  BonClientService.updateBonClient(newRow, oldRow.idBon)
                    .then((response) => {
                      toast.success("Produit vendu modifié avec succès...", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                      refreshProdVendus()
                    })
                    .catch((error) => {
                      console.log(error);
                      toast.error(error.response?.data, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                    });
                  setTimeout(() => resolve(), 500)
                }),
                onRowDelete: (selectedRow) => handleDeleteProduit(selectedRow)
              }}
              actions={[
                {
                  icon: () => <GetAppIcon />,
                  tooltip: "details",
                  onClick: (event, rowData) => {
                    console.log(rowData)
                  },
                }
              ]}
              onSelectionChange={(selectedRows) => console.log(selectedRows)}
              options={{
                sorting: true,
                filtering: true,
                paging: true,
                pageSizeOptions: [2, 5, 10, 20, 25, 50, 100],
                pageSize: 5,
                paginationType: "stepped",
                showFirstLastPageButtons: false,
                paginationPosition: "both",
                exportButton: true,
                exportAllData: true,
                exportFileName: "BON DE COMMANDES",
                addRowPosition: "first",
                actionsColumnIndex: -1,
                selection: true,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
                selectionProps: rowData => ({
                  color: "primary"
                }),
                columnsButton: true,
                rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
                headerStyle: { background: "#226D68", color: "#fff" },
              }}
              title="Liste des produits à vendre"
              icons={{ Add: () => <AddIcon /> }}
            />
          </Grid>
        </Grid>
      </div>

      {printBillModalVisibility && (
        <Modal
          onCancel={() => {
            setPrintBillModalVisibilty(false);
          }}
          visible={printBillModalVisibility}
          title="Détails de la vente"
          footer={false}
          width={800}
        >
          <div ref={componentRef} style={{ marginLeft: '14px', marginRight: '14px', marginTop: '10px' }}>
            {/* ... Votre code existant pour l'impression ... */}
          </div>

          <div className="d-flex justify-content-end">
            <Button type='primary' ref={refPrint} onClick={handlePrint}>Imprimer</Button>
          </div>
        </Modal>
      )}
    </>
  )
}

export default VendreBons